import React from "react";
import styled from "styled-components";

import { LinkStyled } from "../../theme";
import Footer from "../shared/footer";
import { Logo } from "../shared/logo";

export const PageNotFound = () => {
  return (
    <PageNotFoundRoutesStyled>
      <Logo linkTo="/" />
      <ErrorTitle>Error</ErrorTitle>
      <ErrorText>
        Sorry but the page you are looking for does not exist. Have been
        removed, name changed or it is temporarily unavailable.
      </ErrorText>
      <LinkStyled to="/">login / dashboard</LinkStyled>
      <Footer login />
    </PageNotFoundRoutesStyled>
  );
};
const ErrorText = styled.p`
  ${(props) => {
    let current = props.theme;
    return `
        padding:${current.gXL};
        margin:0!important;
        max-width:450px;
        text-align:center;
    `;
  }}
`;
const ErrorTitle = styled.h1`
  ${(props) => {
    let current = props.theme;
    return `
        ${current.fXXL};
        text-transform: uppercase;
    `;
  }}
`;
const PageNotFoundRoutesStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        >a{
            text-align:center;
            .unPrintLogo{
                color:rgb(${current.cOne});
            }
        }
    `;
  }}
`;
